var React = require('react');

function IconProfile (props) {
    return React.createElement("svg",props,[React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M24 24C28.9706 24 33 19.9706 33 15C33 10.0294 28.9706 6 24 6C19.0294 6 15 10.0294 15 15C15 19.9706 19.0294 24 24 24ZM24 25C29.5228 25 34 20.5228 34 15C34 9.47715 29.5228 5 24 5C18.4772 5 14 9.47715 14 15C14 20.5228 18.4772 25 24 25Z","fill":"#2964F6","key":0}),React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M29.7778 29H18.2222C11.4721 29 6 34.4721 6 41.2222C6 42.7563 7.24365 44 8.77778 44H39.2222C40.7563 44 42 42.7563 42 41.2222C42 34.4721 36.5279 29 29.7778 29ZM18.2222 28C10.9198 28 5 33.9198 5 41.2222C5 43.3086 6.69137 45 8.77778 45H39.2222C41.3086 45 43 43.3086 43 41.2222C43 33.9198 37.0802 28 29.7778 28H18.2222Z","fill":"#2964F6","key":1})]);
}

IconProfile.defaultProps = {"width":"48","height":"48","viewBox":"0 0 48 48","fill":"none"};

module.exports = IconProfile;

IconProfile.default = IconProfile;
